import { IAppState } from '../../../AppModulesWrapper';

export const selectIsSubagent = (state: IAppState): boolean => {
  return state.servicePickerWidget.user.isSubAgent;
};
